@if (!isFileUploaded) {
  <div (fileDropped)="handleFileConversionAndUpload($event)" class="dropzone" draganddropzone>
    <input #fileDropRef (change)="handleSelectedFile($event)" accept="application/pdf" class="uploadfield-input" id="fileDropRef" type="file">
    @if (progress == 0) {
      <label for="fileDropRef">Upload {{ downloadButtonText }}</label>
    }
    @if (progress > 0) {
      <ion-progress-bar [buffer]="buffer" [value]="progress" color="primary"/>
    }
  </div>
} @else {
  <div class="button-container">
    <ion-button (click)="downloadDocument()" class="download-document-button" expand="block">
      <ion-icon slot="start" src="/assets/icon/icon_pdf.svg"/>
      {{ downloadButtonText }}
    </ion-button>
    @if (showDeleteButton) {
      <ion-button (click)="deleteDocument()" class="delete-document-button">
        <ion-icon name="trash"/>
      </ion-button>
    }
  </div>
}

